import styled from 'styled-components';
import EasyAccessSvg from '../../../assets/onboardingNew/homepage/easy-access.svg';

const EasyAccessNewIcon = styled(EasyAccessSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '2.4rem'};
height: ${props => props.height || '1.8rem'};
display: flex;
`;

export default EasyAccessNewIcon;
